import React, { createContext, useEffect } from 'react'
import { useLocation } from 'react-router'
import { ClientInterface } from '../types/analytics'
import { client } from './Client'

export const Context = createContext<ClientInterface>(client)

export const Provider: React.FC<React.PropsWithChildren> = ({ children }) => {
  const location = useLocation()
  // One pageview per page load and per in-app navigation
  useEffect(() => client.pageview(window.location.href), [location])
  return <Context.Provider value={client}>{children}</Context.Provider>
}
